import { computed } from 'vue';
import { gql } from '@apollo/client/core';
import { useQuery } from '@vue/apollo-composable';
import { Query } from '@spectee/graphql/api';
import { getAdminData } from '@spectee/graphql/queries';

const document = gql(getAdminData);

type QueryResult = {
  getAdminData: Query['getAdminData'];
};

export function useGetAdminData() {
  const API = useQuery<QueryResult>(document, {});

  const useGetAdminDataRes = computed(() => API.result.value?.getAdminData);
  return {
    ...API,
    useGetAdminDataRes,
  };
}
